import InlineSeparatedNodes from './InlineSeparatedNodes';

export default InlineSeparatedNodes;
export { InlineSeparatedNodes };
